module.exports = __webpack_public_path__ + "staticVue/img/none-info.cd453ef7.png";